import React from 'react';
import { useGetDashboardConsentsQuery } from '../../../api/dashboardApiSlice';
import ConsentPie from '../../metrics/ConsentPie';

const DashboardConsentPie = ( { source, title, publisherId, startDate, endDate } ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetDashboardConsentsQuery({publisherId, startDate, endDate})
  return (
    <ConsentPie title={title} source={source} data={data} loaderProps={{isLoading, isSuccess, retry: refetch}}/>
  )
}

export default DashboardConsentPie
